import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import OrganizationSchema from "./OrganizationSchema";
import LanguageBanner from "./LanguageBanner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function SiteLayout() {
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <OrganizationSchema />
      <Navbar />
      <main className="pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
      <LanguageBanner />
    </div>
  );
}
